import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import "../styles/pages/Legal.css";

export default function LegalPage({ docType, lang = "pl" }) {
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(null);

useEffect(() => {
  let mounted = true;

  const titleMap = {
    privacy: "Polityka prywatności",
    terms: "Regulamin",
  };

  fetch(`/legal/${docType}-${lang}.html`, { cache: "no-store" })
    .then((r) => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.text();
    })
    .then((html) => {
      if (!mounted) return;
      const title = titleMap[docType] ?? "Dokument";
      setDoc({ title, contentHtml: html });
      document.title = `${title} – soMeet`;
    })
    .catch((e) => setError(`Nie udało się pobrać dokumentu: ${e.message}`));

  return () => { mounted = false; };
}, [docType, lang]);

  if (error) {
    return (
      <section className="legal-page">
        <div className="legal-card"><p className="error">{error}</p></div>
      </section>
    );
  }
  if (!doc) {
    return (
      <section className="legal-page">
        <div className="legal-card"><p>Ładowanie…</p></div>
      </section>
    );
  }

  return (
    <section className="legal-page">
      <div className="legal-card">
        <a className="back" href="/">← Strona Główna</a>
        <h1>{doc.title}</h1>
        <p className="meta">
          obowiązuje od dnia publikacji
        </p>
        <article
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(doc.contentHtml) }}
        />
      </div>
    </section>
  );
}
